import { Notification_ReadState } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/notification_pb';
import { blazeDevicePromiseClient } from '~/services/blaze-device-client';

interface SetNotificationReadStateParams {
  name: string;
  readState: Notification_ReadState;
}

export const setNotificationReadState = async ({
  name,
  readState,
}: SetNotificationReadStateParams) =>
  await blazeDevicePromiseClient.setNotificationReadState({
    name,
    readState,
  });
